const getters = {
    sidebar: (state) => state.app.sidebar,
    permissionRoutes: (state) => state.permission.routes,
};

export default getters;
